export interface ExceptionType {
  id: string;
  name: string;
}

export const EXCEPTION_TYPES: ExceptionType[] = [
  { id: '', name: 'All Exceptions' },
  { id: 'Under', name: 'Pricing Under' },
  { id: 'Over', name: 'Pricing Over' },
];

